import { apolloClient } from '@/services/graphql';
import gql from 'graphql-tag';

export const getLatestClientVersion = () =>
  apolloClient.query({
    query: gql`
      query {
        latest {
          name
          files {
            url
            sha512
          }
          version
        }
      }
    `
  });
